var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c(_vm.tag,{tag:"component",staticClass:"btn",attrs:{"href":_vm.content.url}},[_c('span',{staticClass:"btn__label"},[_vm._v(" "+_vm._s(_vm.content.label)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }